<!-- 地产和物业-会员管理 -->

<script setup></script>

<template>
  <div id="authentication">
    <button-router></button-router>
    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
        <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#authentication {
  height: 100%;
}
</style>
